import ko from "knockout";
import register from "flow/knockout/register";
import { MaybeObservable } from "../interfaces/MaybeObservable";
import { cleanHtml } from "flow/utils/cleanHtml";

// Same implementation as knockout's own html binding, except that it cleans the html.
register.registerKnockoutBinding("safeHtml", {
    init() {
        // Prevent binding on the dynamically-injected HTML (as developers are unlikely to expect that, and it has security implications)
        return { controlsDescendantBindings: true };
    },
    update: function (element: HTMLElement, valueAccessor: () => MaybeObservable<string>) {
        const potentiallyUnsafeHtml = ko.unwrap(valueAccessor());
        const safeHtml = cleanHtml(potentiallyUnsafeHtml);
        ko.utils.setHtml(element, safeHtml);
    }
});
